import { loadStripe, Stripe } from '@stripe/stripe-js'

const stripePromise = loadStripe('pk_live_jK3mKu7ANBQpPnAxG5ogVskz00eKEd2pGj')

export const stripeService = {
  async getStripe(): Promise<Stripe | null> {
    try {
      return await stripePromise
    } catch (error) {
      console.error('Failed to load Stripe:', error)
      return null
    }
  },

  async createPaymentIntent(amount: number, currency = 'usd', metadata?: Record<string, string>) {
    if (!amount || amount <= 0) {
      throw new Error('Invalid amount')
    }

    const stripe = await this.getStripe()
    if (!stripe) throw new Error('Stripe not loaded')

    return { amount, currency, metadata }
  },

  async confirmPayment(clientSecret: string, paymentMethodId: string) {
    if (!clientSecret || !paymentMethodId) {
      throw new Error('Client secret and payment method ID are required')
    }
    
    const stripe = await this.getStripe()
    if (!stripe) throw new Error('Stripe not loaded')

    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: paymentMethodId,
    })

    if (error) {
      throw new Error(error.message || 'Payment confirmation failed')
    }

    return paymentIntent
  },

  formatPrice(amount: number, currency = 'usd'): string {
    if (typeof amount !== 'number' || amount < 0) {
      throw new Error('Invalid amount')
    }
    
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
      minimumFractionDigits: 0,
    }).format(amount)
  },

  getCreditPackages() {
    return [
      { id: 'starter', credits: 1000, price: 50, pricePerCredit: 0.05 },
      { id: 'growth', credits: 5000, price: 200, pricePerCredit: 0.04 },
      { id: 'pro', credits: 10000, price: 350, pricePerCredit: 0.035 },
      { id: 'enterprise', credits: 50000, price: 1500, pricePerCredit: 0.03 }
    ]
  }
}